export default __webpack_public_path__ + "static/media/football.efdc78ac.png";